import { render, staticRenderFns } from "./broadcast-summary-widget.vue?vue&type=template&id=35439b17"
import script from "./broadcast-summary-widget.vue?vue&type=script&lang=js"
export * from "./broadcast-summary-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports